import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=eb51cbcc&scoped=true"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=eb51cbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb51cbcc",
  null
  
)

export default component.exports